import { computed } from 'vue'

export function useAnalyticsConfig() {
  // Sprawdź czy analytics są włączone przez zmienną środowiskową
  const isAnalyticsEnabled = computed(() => {
    return import.meta.env.VITE_ENABLE_ANALYTICS === 'true'
  })

  // Sprawdź czy Google Analytics powinien być ładowany
  const shouldLoadGoogleAnalytics = computed(() => {
    return isAnalyticsEnabled.value
  })

  return {
    isAnalyticsEnabled,
    shouldLoadGoogleAnalytics
  }
} 